import { AlertTitle } from '@mui/material'
import { styled } from '@mui/system'
import { forwardRef, MouseEventHandler } from 'react'
import { Severities, Variants } from '../../core/Alert'
import { Button } from '../../core/Button'
import { getAlertIconAndButtonColors } from '../../utils/commonFunctions'
import { AlertCloseButton } from './AlertCloseButton'
import { AlertIcon } from './AlertIcon'

const StyledWrapper = styled('div')(
  {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  { name: 'AlertContent', slot: 'mainWrapper' }
)

const StyledInnerWrapper = styled('div')(
  {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
  },
  { name: 'AlertContent', slot: 'innerWrapper' }
)

const StyledMessageWrapper = styled('div')(
  {
    alignItems: 'flex-start',
    alignSelf: 'flex-end',
  },
  { name: 'AlertContent', slot: 'messageWrapper' }
)

const StyledButtonWrapper = styled('div')(
  {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  { name: 'AlertContent', slot: 'ButtonWrapper' }
)

interface StyledButtonProps {
  alertVariant?: Variants
  alertSeverity?: Severities
}
const StyledButton = styled(Button)<StyledButtonProps>(
  ({ theme, alertVariant, alertSeverity }) => ({
    color: getAlertIconAndButtonColors(theme, alertVariant, alertSeverity) + '!important',
    backgroundColor: 'transparent !important',
    boxShadow: 'none !important',
  }),
  { name: 'AlertContent', slot: 'Button' }
)

const StyledAlertTitle = styled(AlertTitle)(
  ({ theme }: { theme: any }) => {
    return {
      ...theme.typography.body2Medium,
    }
  },
  { name: 'AlertContent', slot: 'AlertTitle' }
)

export interface AlertContentProps {
  severity: Severities
  variant: Variants
  primaryButtonLabel: string
  secondaryButtonLabel: string
  onClickPrimaryButton?: MouseEventHandler
  onClickSecondaryButton?: MouseEventHandler
  onPressCloseIcon?: MouseEventHandler
  children?: React.ReactNode
}

/** @deprecated Use AlertContentProps */
export type OsAlertContentProps = AlertContentProps

// Need to add two buttons
export const AlertContent = forwardRef<HTMLDivElement, AlertContentProps>((props, ref) => {
  void ref
  const {
    severity,
    variant,
    onClickPrimaryButton,
    onClickSecondaryButton,
    primaryButtonLabel,
    secondaryButtonLabel,
    onPressCloseIcon,
    children,
  } = props
  return (
    <StyledWrapper>
      <StyledInnerWrapper>
        <AlertIcon severity={severity} variant={variant} />
        <StyledMessageWrapper>
          {typeof children === 'string' && <StyledAlertTitle>{children}</StyledAlertTitle>}
        </StyledMessageWrapper>
      </StyledInnerWrapper>
      <StyledButtonWrapper>
        {onClickPrimaryButton && (
          <StyledButton
            alertVariant={variant}
            alertSeverity={severity}
            color="info"
            variant="text"
            size="xXSmall"
            onClick={onClickPrimaryButton}
          >
            {primaryButtonLabel}
          </StyledButton>
        )}
        {onClickPrimaryButton && onClickSecondaryButton && '•'}
        {onClickSecondaryButton && (
          <StyledButton
            alertVariant={variant}
            alertSeverity={severity}
            color="info"
            variant="text"
            size="xXSmall"
            onClick={onClickSecondaryButton}
          >
            {secondaryButtonLabel}
          </StyledButton>
        )}
      </StyledButtonWrapper>
      {onPressCloseIcon && (
        <AlertCloseButton onClickCloseIcon={onPressCloseIcon} variant={variant} severity={severity} />
      )}
    </StyledWrapper>
  )
})
